import { useState } from 'react';
import { Button, Modal as ModalDefault } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import HelperNumber from '../../helpers/HelperNumber';
import IKitItem from '../../interfaces/IkitItem';
import { ProposalService } from '../../services';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Modal from '../Modal';
import './styles.scss';

interface IProp {
  proposal: any;
}

const ProposalUpdateKit = ({ proposal }: IProp) => {
  const [kits, setKits] = useState<IKitItem[]>([]);
  const [kitActual, setKitActual] = useState<any>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const [kitSelected, setKitSelected] = useState<any>();
  const [isKitPromotion, setIsKitPromotion] = useState<boolean>(proposal.promotional);
  const navigate = useNavigate();

  const getKits = async () => {
    setIsLoad(true);
    try {
      const response = await ProposalService.GetkitsForUpdate({ ...proposal, "city": null });
      setKits(response.kits);
      setKitActual(response.kitActual);
      setIsLoad(false);
      setShowModal(true);
    } catch (error) {
      setIsLoad(false);
      Modal.show({
        title: "Erro ao buscar kits",
        body: Modal.getErrorMessage(error, proposal.id),
        showCancel: true,
        showConfirm: false,
        onCancelText: "Fechar"
      });
    }
  };
  function SelectedKit(idKit: any, isPromotion: boolean) {
    setKitSelected(idKit);
    setIsKitPromotion(isPromotion);
  }

  const handleProposalKit = async (saveKit: boolean) => {
    setIsLoad(true);
    try {
      await ProposalService.UpdateProposalKit({ ...proposal, "IdKit": (saveKit) ? kitSelected : 0, "IsKitPromotion": isKitPromotion });
      Modal.show({
        title: "Kit da Proposta",
        body: <><p>Kit atualizado com sucesso!</p></>,
        showCancel: false,
        showConfirm: true
      });
      setShowModal(false);
      setIsLoad(false);
      navigate(`/proposal-detail/${proposal.Id}`)
    } catch (error) {
      setIsLoad(false);
      Modal.show({
        title: "Erro ao Salvar novo Kit",
        body: Modal.getErrorMessage(error, proposal.id),
        showCancel: true,
        showConfirm: false,
        onCancelText: "Fechar"
      });
    }
  };

  return (
    <>
      {
        <>
          {
            isLoad &&
            <LoadingSpinner text='Carregando...' />
          }
          {
            <ModalDefault
              show={showModal}
              size={'sm'}
              className={''}
              animation={false}
              backdrop="static"
              keyboard={false}
              style={{ zIndex: '1040' }}
              id={'modalUpdateKit'}
            >
              <ModalDefault.Header>
                <ModalDefault.Title>{'Alterar Kit'}</ModalDefault.Title>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                  onClick={() => { setShowModal(false); }}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalDefault.Header>
              <ModalDefault.Body>
                <>
                  {
                    (kitActual) &&
                    <div className='row kitactual'>
                      {
                        (kitActual?.isKitPromotion) ?
                          <>
                            <p style={{ marginBottom: 0 }}><b>{kitActual?.nameInversor}</b></p>
                            <p style={{ marginBottom: 0 }}><b>Qtd. módulos:</b> {kitActual?.qtdModulos}</p>
                            <p style={{ marginBottom: 0 }}><b>Tipo:</b> {kitActual?.type} </p>
                            <p style={{ marginBottom: 0 }}><b>Geração Estimada:</b> {(HelperNumber.read(Number(kitActual?.geracaoEstimada))).replace(/\R\$\s?/g, '')} kWh</p>

                          </>
                          :
                          <>
                            <p style={{ marginBottom: 0 }}><b>Módulo:</b> {kitActual?.nameModule ?? null}</p>
                            <p style={{ marginBottom: 0 }}><b>Qtd. módulos:</b> {kitActual?.qtdModulos}</p>
                            <p style={{ marginBottom: 0 }}><b>Inversor:</b> {kitActual?.nameInversor ?? null}</p>
                            <p style={{ marginBottom: 0 }}><b>Qtd. Inversor:</b> {kitActual?.qtdInversor ?? 0}</p>
                            <p style={{ marginBottom: 0 }}><b>Geração Estimada:</b> {(HelperNumber.read(Number(kitActual?.geracaoEstimada))).replace(/\R\$\s?/g, '')} kWh</p>
                            <p style={{ marginBottom: 0 }}><b>Potência do sistema:</b> {(HelperNumber.read(Number(kitActual?.potenciaPicoRealDoSistema))).replace(/\R\$\s?/g, '')} kWp</p>
                          </>
                      }
                      <p><b>Valor:</b> {HelperNumber.moneyFormat(kitActual?.valueAll ?? 0)} </p>
                    </div>
                  }
                  <p style={{ marginBottom: 0, fontSize: 12 }}>Selecione o novo kit da proposta abaixo, e clique no botão "Salvar Novo Kit";</p>
                  <div className='row'>
                    <div className="kit-list">
                      <hr style={{ marginBottom: 5, marginTop: 5 }} />
                      {kits?.map((kit: any, index: number) => {
                        let moduleitem = kit?.itens?.find((item: any) => item?.itemType === 1) ?? null;
                        let inverteritem = kit?.itens?.find((item: any) => item?.itemType === 2) ?? null;
                        return (
                          <>
                            {
                              ((Number(kit.valueAll ?? 0)) > 0) &&
                              <div
                                key={kit.idProductInversor}
                                className={`kit-item-update ${kitSelected == kit.idProductInversor ? "kitSelected" : ""}`}
                                onClick={() => { SelectedKit(kit.idProductInversor, (kit.isKitPromotion ?? false)) }}
                              >
                                  <div style={{ textAlign: 'center', float: 'right', display: 'inline-block', marginTop: -8 }}>
                                    {/* <img src="https://gerenciadorblob.blob.core.windows.net/publicresources/Images/LogoPromo.png" alt="Promo" style={{ width: 110, height: 60, marginRight:-20, transform: 'rotate(10deg)' }} /> */}

                                    {/* <div style={{ transform: 'rotate(14deg)' }}>
                                      <i className="bx bx-gift" style={{ fontSize: 22, color: '#1ca113', display: 'block' }} ></i>
                                      <span
                                        style={{
                                          fontSize: 9,
                                          color: '#FFFFFF',
                                          background: '#000000',
                                          padding: 4,
                                          paddingBottom: 7,
                                          fontWeight: 'bold',
                                          display: 'block',
                                          marginTop: 2,
                                        }}
                                      >
                                        <span style={{ color: '#0e8622ff', display: 'block', fontSize: 14.4, lineHeight: 0.5 }}>PROMO</span>
                                      </span>
                                    </div> */}
                                    {/* {
                                      (kit.typeId !== 65 && kit.typeId !==66 && kit.typeId !==67 && kit.type !== 'SOLAR + BESS') ?
                                          <>
                                          <span style={{marginTop:0, display:'block', fontSize:10, textAlign:'left', lineHeight:0}}><i className='bx bx-check' style={{color:'green', fontSize:14, fontWeight:'bold'}}></i> Com</span>
                                          <span style={{display:'block'}}>WEGHOME</span>
                                          </>
                                      :
                                          <>
                                          <span style={{marginTop:0, display:'block', fontSize:10, textAlign:'left', lineHeight:0}}><i className='bx bx-x' style={{color:'red', fontSize:14, fontWeight:'bold'}}></i> Sem</span>
                                          <span style={{display:'block'}}>WEGHOME</span>
                                          </>
                                      } */}
                                  </div>
                                <h5 style={{ marginBottom: 3 }}>{index + 1} - {(kit.isKitPromotion) ? "Kit Promocional" : "Kit Fotovoltaico"}</h5>
                                {
                                  (kit.isKitPromotion) ?
                                    <>
                                      <p style={{ marginBottom: 0 }}>{kit.nameInversor}</p>
                                      {
                                        (kit.type !== 'SOLAR + BESS') ?
                                          <>
                                            <p style={{ marginBottom: 0 }}><b>Tipo:</b> {kit.type} </p>
                                            <p style={{ marginBottom: 0 }}><b>Qtd. módulos:</b> {kit.qtdModulos}</p>
                                            <p style={{ marginBottom: 0 }}><b>Geração Estimada:</b> {(HelperNumber.read(Number(kit.geracaoEstimada))).replace(/\R\$\s?/g, '')} kWh</p>
                                          </>
                                          :
                                          <>
                                            <p style={{ marginBottom: 0 }}><b>Tipo:</b> SOLAR + BATERIA </p>
                                            <p style={{ marginBottom: 0 }}><b>Qtd. Baterias:</b> {kit.nameInversor.match(/\(([^)]+)\)/)?.[1] ?? (kit.nameInversor)} </p>
                                            <p style={{ marginBottom: 0 }}><b>Inversor:</b> {kit.itens[1].product.name}</p>
                                          </>
                                      }
                                    </>
                                    :
                                    <>
                                      <p style={{ marginBottom: 0 }}><b>Módulo:</b> {moduleitem?.product?.name ?? null}</p>
                                      <p style={{ marginBottom: 0 }}><b>Qtd. módulos:</b> {moduleitem.qty}</p>
                                      <p style={{ marginBottom: 0 }}><b>Inversor:</b> {inverteritem?.product?.name ?? null}</p>
                                      <p style={{ marginBottom: 0 }}><b>Qtd. Inversor:</b> {inverteritem.qty ?? 0}</p>
                                      <p style={{ marginBottom: 0 }}><b>Geração Estimada:</b> {(HelperNumber.read(Number(kit.geracaoEstimada))).replace(/\R\$\s?/g, '')} kWh</p>
                                      <p style={{ marginBottom: 0 }}><b>Potência do sistema:</b> {(HelperNumber.read(Number(kit.potenciaPicoRealDoSistema))).replace(/\R\$\s?/g, '')} kWp</p>
                                    </>
                                }
                                <p><b>Valor:</b> {HelperNumber.moneyFormat(kit.valueAll)} </p>
                              </div>
                            }
                          </>
                        )
                      })}
                    </div>
                  </div>
                </>
              </ModalDefault.Body>
              <ModalDefault.Footer>
                <Button className="btn btn-danger btnNO" onClick={() => setShowModal(false)}>Fechar</Button>
                <Button className="btn btn-success btnOk" onClick={() => handleProposalKit(true)}>Salvar Novo Kit</Button>
              </ModalDefault.Footer>
            </ModalDefault>
          }
          <div className="d-flex gap-2">
            <button type="button" onClick={getKits} className="btn btn-warning" style={{ fontSize: 16 }}>Selecionar o Kit</button>
            <button type="button" onClick={() => handleProposalKit(false)} className="btn btn-success btnNext">Salvar Proposta sem alterar Kit</button>
          </div>
        </>
      }
    </>
  )
};

export default ProposalUpdateKit;
